import { gql } from '@apollo/client';
import { VirtualTenant } from './queries/virtualTenant/getVirtualTenants.queries';

export interface Organisation {
  uuid: string;
  name: string;
  email: string;
  country: string;
  code: string;
  tenantCode?: string;
  sourceId?: string;
  isActive: boolean;
  virtualTenant?: VirtualTenant;
}

export interface Member {
  uuid?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  id: string;
  email: string;
  membershipsV2: MembershipV2[];
  enabled: boolean;
}

export interface MembershipV2 {
  enabled: boolean;
  organisation: string;
  rolesWithName: MembershipV2Role[];
}

export interface MembershipV2Role {
  id: string;
  name: string;
}

export const GET_ORGANISATIONS = gql`
  query getOrganisations(
    $pageNumber: Int = 0
    $pageSize: Int = 10
    $search: String = ""
  ) {
    organisationsPage(
      pageNumber: $pageNumber
      pageSize: $pageSize
      search: $search
    ) {
      organisations {
        uuid
        name
        email
        country
        code
        sourceId
        tenantCode
        isActive
        virtualTenant {
          uuid
          code
          tenantCode
        }
      }
      pageNumber
      pageSize
      totalCount
    }
  }
`;

export const GET_ORGANISATION_NAME = gql`
  query organisationsByCodes($codes: [String!]!) {
    organisationsByCodes(codes: $codes) {
      name
    }
  }
`;

export const GET_ALL_ORGANISATIONS = gql`
  query organisations {
    organisations {
      name
      code
      tenantCode
    }
  }
`;
